import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1484f7e1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "custom-tree-node" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("查看")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("添加下级分类")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("删除")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_tree = _resolveComponent("el-tree")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createBlock(_component_el_tree, {
    "allow-drop": _ctx.treeEventHandle.allowDrop,
    "allow-drag": _ctx.treeEventHandle.allowDrag,
    data: _ctx.treeHandle.data,
    draggable: "",
    "node-key": "id",
    "default-expand-all": "",
    props: _ctx.treeHandle.defaultProps,
    onNodeDragStart: _ctx.treeEventHandle.handleDragStart,
    onNodeDragEnter: _ctx.treeEventHandle.handleDragEnter,
    onNodeDragLeave: _ctx.treeEventHandle.handleDragLeave,
    onNodeDragOver: _ctx.treeEventHandle.handleDragOver,
    onNodeDragEnd: _ctx.treeEventHandle.handleDragEnd,
    onNodeDrop: _ctx.treeEventHandle.handleDrop
  }, {
    default: _withCtx(({ node, data }) => [
      _createElementVNode("span", _hoisted_1, [
        _createElementVNode("span", null, _toDisplayString(node.label), 1),
        _createElementVNode("span", {
          onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
        }, [
          _createVNode(_component_el_space, { wrap: "" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "text",
                onClick: ($event: any) => (_ctx.$emit('onEdit', data))
              }, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 2
          }, 1024),
          _createVNode(_component_el_space, { wrap: "" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "text",
                onClick: ($event: any) => (_ctx.$emit('onCheck', data))
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 2
          }, 1024),
          _createVNode(_component_el_space, { wrap: "" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "text",
                onClick: ($event: any) => (_ctx.$emit('onAddChild', data))
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 2
          }, 1024),
          _createVNode(_component_el_space, { wrap: "" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "text",
                class: "danger",
                onClick: ($event: any) => (_ctx.handleDeleteNode(data.id))
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 2
          }, 1024),
          _createVNode(_component_el_space, { wrap: "" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_switch, {
                "model-value": data.status === 1,
                "inline-prompt": "",
                "active-text": "开",
                "inactive-text": "关",
                onClick: ($event: any) => (_ctx.handleSwitchClick(data))
              }, null, 8, ["model-value", "onClick"])
            ]),
            _: 2
          }, 1024)
        ])
      ])
    ]),
    _: 1
  }, 8, ["allow-drop", "allow-drag", "data", "props", "onNodeDragStart", "onNodeDragEnter", "onNodeDragLeave", "onNodeDragOver", "onNodeDragEnd", "onNodeDrop"])), [
    [_directive_loading, _ctx.treeHandle.loading]
  ])
}